import { useState, type ReactNode } from "react";
import { Flag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

interface Props {
  onFlag: (note?: string) => void;
  /** Controlled open — with `anchor`, the popover is opened from elsewhere (a menu item). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** Replaces the icon trigger with a positioning anchor. */
  anchor?: ReactNode;
}

export function FlagPopover({ onFlag, open: openProp, onOpenChange, anchor }: Props) {
  const [ownOpen, setOwnOpen] = useState(false);
  const open = openProp ?? ownOpen;
  const setOpen = onOpenChange ?? setOwnOpen;
  const [note, setNote] = useState("");

  const handleConfirm = () => {
    onFlag(note.trim() || undefined);
    setOpen(false);
    setNote("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      {anchor ? (
        <PopoverAnchor asChild>{anchor}</PopoverAnchor>
      ) : (
        <PopoverTrigger asChild>
          <Button variant="ghost" size="icon-sm" title="Flag for later" className="text-amber-500/70 hover:text-amber-500">
            <Flag className="size-3.5" />
          </Button>
        </PopoverTrigger>
      )}
      <PopoverContent className="w-56 p-2" align="start">
        <div className="flex flex-col gap-2">
          <input
            type="text"
            placeholder="Why is this interesting?"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="rounded border bg-background px-2 py-1 text-sm"
            onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
          />
          <Button size="sm" onClick={handleConfirm}>
            Flag
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
